import { Input, InputValues } from '../common/types/inputs'
import { normalizeNumber } from './number-utils'

export const getNumeric = (input: Input<string>, inputValues: InputValues) => {
    return normalizeNumber(input.get(inputValues).trim())
}
